import Authorization from "../../generics/authorization";
import TabNavigation from "../../common/TabNavigation";
import PredictiveWidgetTop from "./PredictiveWidgetTop";
import { getCookie } from "../../serviceWorker";
import convergedPredictiveFilterDashlets from "./convergedPredictiveFilterDashlets";
import { useLocation } from "react-router-dom";
import { routeURLs } from "../../utils/enums";

const isUIConvergence = getCookie("cl-analytics");
const xValue = 0;
const wValue = 12;
const predictiveContentHeight = 60;
const convergedInCardTabsFilterDashlets = {
  filterDashlets: convergedPredictiveFilterDashlets.filterDashlets.filter(
    ({ name }) => name !== "predictive-tabs",
  ),
};

const Page = () => {
  const { pathname } = useLocation();
  const normalizedPath = pathname.replace(/\/+$/, "");
  const tabsRenderInCard =
    normalizedPath.endsWith(routeURLs.pn) ||
    normalizedPath.endsWith(routeURLs.bwf);
  const filterDashlets = isUIConvergence
    ? tabsRenderInCard
      ? convergedInCardTabsFilterDashlets
      : convergedPredictiveFilterDashlets
    : {
        filterDashlets: [
          {
            component: TabNavigation,
            name: "tab-nav-insights",
            layout: { x: xValue, y: 0, w: wValue, h: 9 },
            style: { zIndex: 1 },
          },
        ],
      };

  const pageProps = {
    ...filterDashlets,
    dashlets: [
      {
        component: PredictiveWidgetTop,
        name: "predictive-path-view",
        layout: { x: xValue, y: 1, w: wValue, h: predictiveContentHeight },
      },
    ],
    checkPageAccess: false,
  };

  return <Authorization pageProps={pageProps} />;
};

export default Page;
